import React from 'react';
import { Button } from '../../ui/button';
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription,
} from '../../ui/dialog';
import { Clock, Edit, Edit3 } from 'lucide-react';
import { formatTimeLisbon, formatOnlyDateLisbon } from '../../../lib/utils';

export default function ModalRegistosProducao({
  open,
  onOpenChange,
  operacao,
  registos = [],
  onEditRegisto,
}) {
  return (
    <Dialog
      open={open}
      onOpenChange={(v) => {
        onOpenChange(v);
      }}
    >
      <DialogContent className="max-w-4xl max-h-[85vh] overflow-y-auto" data-testid="registos-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Edit3 className="h-5 w-5 text-primary" />
            Registos de Produção — {operacao?.nome || 'Operação'}
          </DialogTitle>
          <DialogDescription>
            Clique num registo para editar os dados (hora, quantidade, etc.)
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-3 mt-4">
          {registos.length === 0 ? (
            <div className="text-center py-8 text-stone-500">
              <Clock className="h-12 w-12 mx-auto mb-3 text-stone-300" />
              <p>Nenhum registo de produção encontrado para esta operação.</p>
            </div>
          ) : (
            <div className="overflow-x-auto">
              <table className="w-full text-sm">
                <thead>
                  <tr className="text-left text-xs text-stone-600 border-b bg-stone-50">
                    <th className="py-2 px-3">Operador</th>
                    <th className="py-2 px-3">Data</th>
                    <th className="py-2 px-3">Início</th>
                    <th className="py-2 px-3">Fim</th>
                    <th className="py-2 px-3 text-right">Duração</th>
                    <th className="py-2 px-3 text-right">Peças</th>
                    <th className="py-2 px-3 text-right">Eficiência</th>
                    <th className="py-2 px-3 text-center">Ações</th>
                  </tr>
                </thead>
                <tbody>
                  {registos.map((reg) => {
                    const duracao = reg.tempo_produtivo_segundos || reg.tempo_total_segundos || 0;
                    const horas = Math.floor(duracao / 3600);
                    const mins = Math.floor((duracao % 3600) / 60);
                    const duracaoStr = horas > 0 ? `${horas}h ${mins}m` : `${mins}m`;
                    const foiEditado = reg.historico_edicoes && reg.historico_edicoes.length > 0;

                    return (
                      <tr
                        key={reg.id}
                        className={`border-b last:border-0 hover:bg-stone-50 ${foiEditado ? 'bg-amber-50/50' : ''}`}
                      >
                        <td className="py-2.5 px-3">
                          <div className="flex items-center gap-2">
                            {reg.operador_foto ? (
                              <img src={reg.operador_foto} alt="" className="w-6 h-6 rounded-full object-cover" />
                            ) : (
                              <div className="w-6 h-6 rounded-full bg-primary/10 flex items-center justify-center text-xs font-bold text-primary">
                                {reg.operador_nome?.charAt(0) || '?'}
                              </div>
                            )}
                            <span className="font-medium">{reg.operador_nome || 'N/A'}</span>
                            {foiEditado && (
                              <span
                                className="text-[10px] px-1.5 py-0.5 bg-amber-100 text-amber-700 rounded font-medium"
                                title={`Editado ${reg.historico_edicoes.length}x — ${reg.motivo_edicao || 'Correção'}`}
                              >
                                EDITADO
                              </span>
                            )}
                          </div>
                        </td>
                        <td className="py-2.5 px-3 text-stone-600">{formatOnlyDateLisbon(reg.inicio)}</td>
                        <td className="py-2.5 px-3 font-mono text-xs">{formatTimeLisbon(reg.inicio)}</td>
                        <td className="py-2.5 px-3 font-mono text-xs">
                          {reg.fim ? formatTimeLisbon(reg.fim) : reg.ativo ? 'Em curso' : '-'}
                        </td>
                        <td className="py-2.5 px-3 text-right">{duracaoStr}</td>
                        <td className="py-2.5 px-3 text-right font-semibold">{reg.quantidade_produzida || 0}</td>
                        <td
                          className={`py-2.5 px-3 text-right font-bold ${
                            (reg.eficiencia_percentual || 0) >= 100
                              ? 'text-green-600'
                              : (reg.eficiencia_percentual || 0) >= 80
                              ? 'text-amber-600'
                              : 'text-red-600'
                          }`}
                        >
                          {Math.round(reg.eficiencia_percentual || 0)}%
                        </td>
                        <td className="py-2.5 px-3 text-center">
                          <Button
                            variant="ghost"
                            size="sm"
                            className="h-8 w-8 p-0"
                            onClick={() => onEditRegisto && onEditRegisto(reg.id)}
                            title="Editar registo"
                            data-testid={`editar-registo-${reg.id}`}
                          >
                            <Edit className="h-4 w-4" />
                          </Button>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )}
        </div>

        <div className="flex justify-end mt-4">
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Fechar
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
